import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
/*import axios from 'axios';*/
const LoginForm= () => {
    
   
   const [email,setEmail] = useState('');
   const [pass,setPass] = useState('');
   const [errors,setErrors] =useState('');
   const navigate = useNavigate(); // For navigation
     const handleLogin =(e) => {
        e.preventDefault(); // Prevent form default behavior
        const formData=new FormData();
        formData.append("jsonData" , JSON.stringify({
            "email":email,
            "userPass":pass,
          }));
          sessionStorage.setItem('fullName', "Demo");
        sessionStorage.setItem('email', email);
        sessionStorage.setItem('role', "Admin");
        navigate("/dashboard");
        window.location.reload();
        /* const REST_API_BASE_URL = `http://localhost:8081/api/login`;
      const loginIn= (formData) => axios.post(REST_API_BASE_URL,formData);
      loginIn(formData)
        .then((response) => {
        window.alert(`you are going to login`+formData);
        const logData=response.data;
        sessionStorage.setItem('fullName', logData.fulName);
        sessionStorage.setItem('email', logData.email);
        sessionStorage.setItem('role', logData.role);
          // After deletion, redirect to another page (e.g., home or item list)
          navigate("/dashboard"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          setErrors(error);
          
          
        }); */
     }
   
    return (
     <div className="container" >
  <div className="auth-wrapper">
    <form>
      <div className="auth-box">
        <a href="#!" className="auth-logo mb-4">
          <img src="assets/images/logo.jpg" alt="Webnet logo" />
        </a>
        <h4 className="mb-4">Login</h4>
        <div className="mb-3">
          <label className="form-label" htmlFor="email">Your email <span className="text-danger">*</span></label>
          <input type="text" id="email" className="form-control" placeholder="Enter your email" onChange={(e)=>setEmail(e.target.value)}/>
        </div>
        <div className="mb-2">
          <label className="form-label" htmlFor="pwd">Your password <span className="text-danger">*</span></label>
          <div className="input-group">
            <input type="password" id="pwd" className="form-control" placeholder="Enter password" />
            <button className="btn btn-outline-secondary" type="button">
              <i className="ri-eye-line text-primary" />
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <a href="/forget" className="text-decoration-underline">Forgot password?</a>
        </div>
        <div className="mb-3 d-grid gap-2">
          <button type="submit" className="btn btn-primary" onClick={handleLogin}>Login</button>
          <a href="/register" className="btn btn-secondary">Not registered? Signup</a>
          <p>Do you want to login from <a href="#"><u>google</u></a> or <a href="#"><u>facebook</u></a></p>
        </div>
      </div>
    </form>
  </div>
</div>

     

    );
}
export default LoginForm;
